import Link from 'next/link';
import { Home, Megaphone } from 'lucide-react';
import { Button } from '../../ui/button.jsx';
import { HelpCenterNavButton } from '../../ui-custom/help-center-nav-button.jsx';
import { ThemeToggle } from '../../../contexts/theme-toggle.jsx';
import { cn } from '../../../lib/utils.js';
import { DesktopMenu } from './desktop-menu';
import { Logo } from './logo';
import { MobileMenu } from './mobile-menu';
import { UserNav } from './user-nav';
import { LoginButton } from './login-button';
export { UserNavbarAvatar } from './user-nav';
export var Navbar = function (_a) {
    var logo = _a.logo, menu = _a.menu, _b = _a.mobileExtraLinks, mobileExtraLinks = _b === void 0 ? [] : _b, auth = _a.auth, userAvatarSlot = _a.userAvatarSlot, notificationsSlot = _a.notificationsSlot, className = _a.className, _c = _a.showThemeToggle, showThemeToggle = _c === void 0 ? false : _c, _d = _a.showFanVoice, showFanVoice = _d === void 0 ? false : _d, mobileMenuClassName = _a.mobileMenuClassName, menuItemClassName = _a.menuItemClassName, _e = _a.hideLogo, hideLogo = _e === void 0 ? false : _e, _f = _a.centerMenu, centerMenu = _f === void 0 ? false : _f, helpCenterUrl = _a.helpCenterUrl;
    return (<header className={cn('border-border bg-background border-b px-4 py-2.5 lg:py-0', className)}>
      <div className="container px-0">
        <nav aria-label="Main navigation" className={cn('hidden min-h-[56px] justify-between lg:flex', centerMenu && 'relative')}>
          <div className="flex items-center gap-6">
            {!hideLogo && <Logo {...logo}/>}

            <div className={cn('flex items-center', centerMenu && 'absolute left-1/2 -translate-x-1/2')} id="gdo">
              <DesktopMenu menu={menu} menuItemClassName={menuItemClassName}/>
            </div>
          </div>
          <div className="flex items-center gap-2">
            {showFanVoice && (<Button asChild variant="ghost" size="sm" title="Report an Issue">
                <Link target="_blank" href="https://govinity.fanvoice.ai/reportissue/bugs-features">
                  <Megaphone className="h-4 w-4"/>
                </Link>
              </Button>)}
            {showThemeToggle && <ThemeToggle />}
            {notificationsSlot}
            <HelpCenterNavButton href={helpCenterUrl}/>
            {auth.showAccount && (<Button asChild variant="outline" size="sm">
                <Link href="/account">
                  <Home className="h-4 w-4"/> Account
                </Link>
              </Button>)}
            {auth.showUserNav && (<UserNav logout={auth.logout} userAvatarSlot={userAvatarSlot} citizenPortalUrl={auth.citizenPortalUrl} governmentPortalUrl={auth.governmentPortalUrl} settingsUrl={auth.settingsUrl} showAdmin={auth.showAdmin} showAccount={auth.showAccount} userMenuLabel={auth.userMenuLabel}/>)}
            {auth.login && <LoginButton loginUrl={auth.login.url}>{auth.login.text}</LoginButton>}
            {auth.signup && (<LoginButton loginUrl={auth.signup.url} isSignup variant="default">
                {auth.signup.text}
              </LoginButton>)}
          </div>
        </nav>
        <MobileMenu logo={logo} helpCenterUrl={helpCenterUrl} hideLogo={hideLogo} menu={menu} mobileExtraLinks={mobileExtraLinks} auth={auth} userAvatarSlot={userAvatarSlot} endSlot={notificationsSlot} showThemeToggle={showThemeToggle} className={mobileMenuClassName} showFanVoice={showFanVoice}/>
      </div>
    </header>);
};
